import { useEffect } from "react";
import { useSelector } from "react-redux";
import { draftDialogKickSelector } from "store/bailiff/draft/dialog/draft_dialog.selector";
//
//component
//redux
//selector
//actions
export const TriggerChange = ({ audio, trigger }) => {
  // -------------------------- VAR ----------------------------
  // -------------------------- STATE --------------------------
  // -------------------------- REDUX --------------------------
  const kick = useSelector(draftDialogKickSelector);

  // -------------------------- USE EFFECT ---------------------
  useEffect(() => {
    if (trigger && audio) {
      const second = trigger?.split("-")[2];
      const round = parseFloat(second);
      audio.currentTime = round;
    }
  }, [audio, trigger]);

  // trigger kick.
  useEffect(() => {
    if (kick && audio) {
      const second = kick?.split("-")[2];
      const round = parseFloat(second);
      audio.currentTime = round;
    }
  }, [audio, kick]);
  // -------------------------- RETURN --------------------------
  return <></>;
};
export default TriggerChange;
